import React, { useState } from "react";
import styled from "styled-components";
import { ContentWrapper } from "../../styled-components/shared";
import UploadBox from "../../components/UploadBox";
import {
  Button,
  TextField
} from "@zebra-fed/zds-react-desktop";
import {useTranslation} from "react-i18next";

// Styled Components
const TopSection = styled.div`
  display: flex;
  margin-top: 0;
  justify-content: space-between;
  width: 70%;
`;
const MidSection = styled.div`
  margin-top: 0;
  margin-bottom: 20px;
`;
const StyledHeader = styled.h1`
  font-size: 20px;
  color: #007ABA;
  margin-left: 10px;
`;
const StyledTextField = styled(TextField)`
  width: 213px;
  height: 40px;
  display: flex;
`;
const StyledDiv = styled.div`
  margin-top: 30px;
`;
const StyledP = styled.p`
  color: #616161;
  margin-left: 10px;
`;

export default function AddDevicesPage() {
  const [singleDevice, setSingleDevice] = useState({
    modelNum: "",
    serialNum: "",
    siteName: "",
  });

  const ButtonStyles = {
    marginTop: "14px",
    height: "32px",
    width: "128px",
    minWidth: "113px",
    lineHeight: "32px",
    marginLeft: "0px",
  };

  const {t} = useTranslation()

  function onSubmit() {
    let errorString = ""
    if (singleDevice.modelNum === "" || singleDevice.serialNum === "" || singleDevice.siteName === "") {
      errorString+=t('messages.error.err38');
    } 
    if(errorString === "") {
      uploadData(singleDevice)
    } else {
      alert(errorString)
    }
  };

  function uploadData(singleDevice) {
    let modelNumber = singleDevice.modelNum;
    alert(
        t('messages.success.success7',{modelNumber} )
    );
    clearForm();
  };

  function clearForm() {
    //TODO: There is no way to reset the site value at the moment
    setSingleDevice({ modelNum: "", serialNum: "", siteName: "" });
  };

  function onDrop(files) {
    //TODO: Upload to backend
    if (files.length > 0) {
      alert(
        `${files.length} file${
          files.length > 1 ? "s" : ""
        } uploaded to somehwere`
      );
    } else {
      alert(t('messages.error.err39')); //`Error. Please check the file type`
    }
  };

  return (
    <ContentWrapper>
      <TopSection>
        <StyledHeader>{t('addASingleDevice')}</StyledHeader>
      </TopSection>

      <MidSection>
        <TopSection style={{maxWidth: '1129px'}}>
          <StyledTextField
              placeholder={t('modelNumber')}
              value={singleDevice.modelNum}
              onChange={(x, val) => setSingleDevice({...singleDevice, modelNum: val})}
          />
          <StyledTextField
              placeholder={t('serialNUmber')}
              value={singleDevice.serialNum}
              onChange={(x, val) => setSingleDevice({...singleDevice, serialNum: val})}
          />
          <StyledTextField
              placeholder={t('siteNumber')}
              value={singleDevice.siteName}
              onChange={(x, val) => setSingleDevice({...singleDevice, siteName: val})}
          />
          <Button style={ButtonStyles} type="primary" onClick={onSubmit}>
            {t('addDevice')}
          </Button>
        </TopSection>

        <StyledDiv>
          <StyledP>{t('or')}</StyledP>
        </StyledDiv>
      </MidSection>
      <UploadBox 
        accept={[".csv", ".xlsx"]} 
        onDrop={onDrop} 
        title={t('uploadFileToAddDevices')}
        subtitle={t('messages.reminder.uploadInAddDevice')}
      />
    </ContentWrapper>
  );
}
